import {Ref, ref} from "vue";
import DocumentWarningBlocks from "@/services/firebase/firestore/documents/DocumentWarningBlocks";
import {FirebaseService} from "@/services/firebase/FirebaseService";
import {Exclude} from "class-transformer";
import ModelWarningBlockNotification from "@models/v2/firebase/warning-blocks/ModelWarningBlockNotification";

export class ServiceWarningBlocks {
	private static _instance: ServiceWarningBlocks | null = null;
	private _warningBlocks: Ref<DocumentWarningBlocks | null> = ref(null);

	static of(): ServiceWarningBlocks {
		if (ServiceWarningBlocks._instance === null) {
			ServiceWarningBlocks._instance = new ServiceWarningBlocks();
		}

		return ServiceWarningBlocks._instance;
	}

	get warningBlocks(): Ref<DocumentWarningBlocks | null> {
		return this._warningBlocks;
	}

	set warningBlocks(value: DocumentWarningBlocks | null) {
		if (value) {
			const getters = this.getAllGetters<DocumentWarningBlocks>(value);

			(Object.keys(getters) as (keyof DocumentWarningBlocks)[])
				.filter((key): key is Exclude<keyof DocumentWarningBlocks, "type"> => key !== "type")
				.forEach((key) => {
					const originalValue = value[key];

					if (Array.isArray(originalValue)) {
						value[key] = this.filterWarningBlocks(originalValue);
					}
				});
		}

		this._warningBlocks.value = value;
	}

	private getAllGetters<T extends object>(obj: T): {
		[K in keyof T as T[K] extends (...args: any) => any ? never : K]: T[K]
	} {
		const proto = Object.getPrototypeOf(obj);
		const descriptors = Object.getOwnPropertyDescriptors(proto);

		const result: any = {};

		for (const [key, descriptor] of Object.entries(descriptors)) {
			if (typeof descriptor.get === 'function') {
				try {
					result[key] = (obj as any)[key];
				} catch (e) {
					result[key] = undefined;
				}
			}
		}

		return result;
	}

	private filterWarningBlocks(value: ModelWarningBlockNotification[]) {
		return [...value].filter(v => this.validateWarningBlock(v));
	}

	private validateWarningBlock(block: ModelWarningBlockNotification): boolean {
		return (
			block.isActive !== undefined &&
			block.en !== undefined &&
			block.ru !== undefined &&
			block.kz !== undefined &&
			block.uz !== undefined &&
			block.order !== undefined &&
			block.tag !== undefined
		);
	}

	public async fetchWarningBlocks() {
		try {
			await FirebaseService.of().firestoreService?.fetchWarningBlocksDocument();
		} catch (e) {
			console.log(e);
		}
	}
}
